<template>
  <div class="news">
    <div class="banner">
      <div class="banner-img">
        <img src="../assets/img/top2.png" />
      </div>
      <div class="banner-title">
        <p>{{ title }}</p>
      </div>
    </div>
    <div class="news-section">
      <div class="row">
        <div class="col-md-1 col-sm-0 col-xs-0 col-lg-2"></div>
        <div
          class="news-section-content col-md-10 col-sm-12 col-xs-12 col-lg-8"
        >
          <div class="content-nav-item">
            <div class="company row">
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <p v-if="this.$root.language == 1" class="wow animate__animated animate__fadeInUp">
                  公司高度重视技术研发工作，2019年投入3,050万元在工厂成立技术研发中心，2021年被评为运城市企业技术研发中心。公司每年从产品销售收入中提取不少于3.5%的经费用于科技研发，分别在上海和山西建有独立的、高标准的实验室，按照ISO/IEC17025建立的炭黑实验室通过CNAS认证。公司高度重视校企业合作，与山西煤炭化学研究所、天津大学、青岛科技大学、中北大学等多家行业内知名高校建立稳定的合作关系。公司目前已获得国家授权专利26项，参编国家标准5项（3项已发布，2项编制中）。
                </p>
                <p v-if="this.$root.language != 1" class="wow animate__animated animate__fadeInUp">
                  Anlun highly values the importance of R&D.In 2019, the company invested 30.5 million yuan to set up a R&D center in the plant,and continued to invest not less than 3.5% of its annual revenue.In 2021, it was rated as Yuncheng City Enterprise Technology R&D center.Two high standard carbon black laboratories were set up in Shanxi plant and Shanghai respectively.The carbon black laboratories were set up in accordance with ISO/IEC17025 standard and passed CNAS certification.The company also highly values the importance of cooperations with universities.  Stable cooperative relations had been established with well known universities in the industry, such as Shanxi Institute of Coal Chemistry, Tianjin University, Qingdao University of Science & Technology, and Central North University.  The company has been granted 26 national patents and participated in the preparation of 5 national standards (3 had been issued and 2 pending).
                </p>
              </div>
              <div class="companyImg col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <img class="wow animate__animated animate__fadeInUp" src="../assets/img/yf1.jpg" />
              </div>
            </div>
            <el-divider class="el-divider-active"></el-divider>
            <div class="customer row">
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <img class="wow animate__animated animate__fadeInUp" src="../assets/img/yf2.jpg" style="width: 80%" />
              </div>
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <h4 class="wow animate__animated animate__fadeInUp">
                  {{this.$root.language == 1?'目前，安仑化工拥有以下5大核心竞争力，更好地满足日益增长的客户需要':'At present, Anlun has the following 5 core competitiveness which better meet the growing demand of customers.'}}
                </h4>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'1.稳定可靠的原料供应能力':'1.Stable and reliable raw material supply.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'2.原料油深加工是定制化产品的基础':'2.Deep processing of tar oil is the foundation for customized products.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'3.定制化产品满足客户日益增长的应用需求':'3.Customized products meet the growing application need of customers.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'4.灵活的仓储、包装和运输能力':'4.Flexible warehouse storage, packaging and transportation capability.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'5.五项服务助力客户发展':'5.Five Service Standards to help customers to develop their markets.'}}</p>
              </div>
            </div>
            <el-divider class="el-divider-active"></el-divider>
            <div class="product row">
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <h4 class="wow animate__animated animate__fadeInUp">
                  {{this.$root.language == 1?'同时，依托强大的研发能力，安仑化工现已形成5大产品系列':'At the same time, based on strong R&D capability, Anlun has developed 5 major product lines'}}
                </h4>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'1.高性能轮胎用胎面炭黑':'1.Carbon black surface tread for high performance tires.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'2.工业橡胶制品用高洁净炭黑':'2.High cleanliness carbon black for industrial rubber products.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'3.色母粒用中高色素洁净炭黑':'3.High purity medium and high pigment carbon black.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'4.液体应用低中高色素炭黑':'4.Low, medium and high pigment carbon black for liquid application.'}}</p>
                <p class="wow animate__animated animate__fadeInUp">{{this.$root.language == 1?'5.环保系列产品':'5.Environmentally friendly carbon black series.'}}</p>
              </div>
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <img class="wow animate__animated animate__fadeInUp" src="../assets/img/yf3.jpg" style="width: 80%" />
              </div>
            </div>
            <el-divider class="el-divider-active"></el-divider>
            <div class="end row">
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <img class="wow animate__animated animate__fadeInUp" src="../assets/img/yf4.jpg" style="width: 80%" />
              </div>
              <div class="col-lg-6 col-md-6 col-ms-12 col-xs-12">
                <p class="wow animate__animated animate__fadeInUp">
                  {{this.$root.language == 1?'未来3-5年，安仑化工将持续加大研发投入，在橡胶应用，树脂应用，液体应用及新能源领域开发一系列炭黑及炭材料产品，满足客户应用需求的同时，持续推进绿色低碳发展，落实“双碳”行动，共建美丽家园。':'In the next 3-5 years, Anlun will continue its R&D on a series of carbon black and carbon material products in areas of rubber application, resin application, liquid application, and new energy market.  While meeting customer needs, Anlun will continue to promote green and low carbon technology to follow the ‘double carbon’ initiative to help build a green and beautiful country.'}}

                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-1 col-xs-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  name: "news",
  components: {},
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1,
      title: this.$root.language ==1?"技术研发":"Research and Development",
      firstList: [
        {
          Id: 1,
          Title: "1系炭黑",
          Type: 1,
          Img: require("../assets/img/N123.jpg"),
          children: [
            {
              Id: 11,
              Content:
                "超高耐磨，正常结构的炭黑，混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N110",
              Type: 1,
            },
            {
              Id: 12,
              Content:
                "超高耐磨，正常结构的炭黑，粒径较小，加工件能稍差。混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N115",
              Type: 1,
            },
            {
              Id: 13,
              Content:
                "超高耐磨，高结构的炭黑，粒径较大，具有良好的加工性能，混炼胶具有很强的耐磨性能，但比N134稍差，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N121",
              Type: 1,
            },
            {
              Id: 14,
              Content:
                "超高耐磨，高结构的炭黑，混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N134",
              Type: 1,
            },
          ],
        },
        {
          Id: 2,
          Title: "2系炭黑",
          Type: 1,
          Img: require("../assets/img/N220.jpg"),
          children: [
            {
              Id: 21,
              Content:
                "超耐磨，低结构炭黑，混炼胶具有良好的耐切割性能，主要用于工程轮胎，如雨林胎等",
              CreateTime: "2021-08-24 15:48",
              Title: "N219",
              Type: 1,
            },
            {
              Id: 22,
              Content: "超耐磨，正常结构炭黑，主要用于轮胎胎面，输送带等",
              CreateTime: "2021-08-24 15:48",
              Title: "N220",
              Type: 1,
            },
            {
              Id: 23,
              Content:
                "超耐磨，高结构炭黑，混炼胶具有良好的耐磨性能，主要用于全钢、半钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N234",
              Type: 1,
            },
          ],
        },
        {
          Id: 3,
          Title: "3系炭黑",
          Type: 1,
          Img: require("../assets/img/N375.jpg"),
          children: [
            {
              Id: 31,
              Content:
                "高耐磨，低结构炭黑，混炼胶生热低，硬度低，主要用于子午胎钢丝结合层",
              CreateTime: "2021-08-24 15:48",
              Title: "N326",
              Type: 1,
            },
            {
              Id: 32,
              Content:
                "高耐磨，正常结构炭黑，主要用于斜交胎、子午胎生产，以及橡胶制品的生产，用途广泛",
              CreateTime: "2021-08-24 15:48",
              Title: "N330",
              Type: 1,
            },
            {
              Id: 33,
              Content:
                "高耐磨，高结构炭黑，混炼胶补强性能、加工性能均衡，主要用于斜交胎、子午胎生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N339",
              Type: 1,
            },
            {
              Id: 33,
              Content: "高耐磨，高结构炭黑，类似N339的特性，主要用于子午胎生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N347",
              Type: 1,
            },
            {
              Id: 33,
              Content:
                "高耐磨、高结构炭黑，较大的粒径，主要用于半钢子午胎，轮胎内胎生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N351",
              Type: 1,
            },
            {
              Id: 33,
              Content:
                "高耐磨，高结构炭黑，类似N339的特性，补强性能稍好，主要用于子午轮胎的生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N375",
              Type: 1,
            },
          ],
        },
        {
          Id: 4,
          Title: "5系炭黑",
          Type: 1,
          Img: require("../assets/img/N539.jpg"),
          children: [
            {
              Id: 41,
              Content: "软质炭黑，主要用于轮胎、内胎、胶管、橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N539",
              Type: 1,
            },
            {
              Id: 42,
              Content:
                "软质、高结构炭黑。主要要用于子午轮胎、内胎、胶管、橡胶制品",
              CreateTime: "2021-08-24 15:48",
              Title: "N550",
              Type: 1,
            },
          ],
        },
        {
          Id: 5,
          Title: "6系炭黑",
          Type: 1,
          Img: require("../assets/img/pt.jpg"),
          children: [
            {
              Id: 51,
              Content:
                "软质正常结构炭黑。主要用于斜交胎、子午轮胎、内胎、胶管、橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N660",
              Type: 1,
            },
          ],
        },
        {
          Id: 6,
          Title: "7系炭黑",
          Type: 1,
          Img: require("../assets/img/pt.jpg"),
          children: [
            {
              Id: 61,
              Content: "软质极低结构炭黑，粒径大，结构低，主要用于橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N762",
              Type: 1,
            },
            {
              Id: 22,
              Content:
                "软质低结构炭黑，粒径大，主要用于轮胎气密层、内胎、胶管、橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N774",
              Type: 1,
            },
          ],
        },
      ],
      secondList: [
        {
          Id: 10,
          Title: "特碳",
          Type: 2,
          Img: require("../assets/img/tt.jpg"),
          children: [
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL271",
              Type: 2,
            },
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL272",
              Type: 2,
            },
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL273",
              Type: 2,
            },
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL801",
              Type: 2,
            },
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL802",
              Type: 2,
            },
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL803",
              Type: 2,
            },
            {
              Id: 101,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL804",
              Type: 2,
            },
          ],
        },
      ],
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      if (this.newstype == 1) {
        this.newsList = this.firstList;
      } else {
        this.newsList = this.secondList;
      }
    },
  },
  mounted() {
    this.loadData();
    new WOW().init();
    // this.postData()
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    margin-bottom: 50px;

    &-content {
      background-color: #eeeeee;
      border: none;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;
        cursor: pointer;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 100%;
        margin: 50px auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        border: 1px solid #cccccc;
        background-color: rgb(250, 250, 250);
        //border: 1px solid blue;
        .company {
          width: 100%;
          padding: 80px;
          p {
            color: #000000;
            text-indent: 2em;
            padding-top: 20px;
            line-height: 2;
          }
          img {
            width: 80%;
            margin: 0 10%;
          }
        }
        .customer {
          padding: 80px;
          img {
            margin: 0 auto;
          }
          h4 {
            padding-left: 10%;
            padding-bottom: 25px;
          }
          p {
            padding: 0 0 15px 10%;
            padding-bottom: 25px;
          }
        }
        .product {
          padding: 80px;
          img {
            width: 80%;
            margin: 0 10%;
          }
          h4 {
            padding-bottom: 25px;
          }
          p {
            padding-bottom: 15px;
          }
        }
        .end {
          padding: 80px;
          img {
            margin: 0 auto;
          }
          p {
            padding: 50px 25px 15px 10%;
            // padding-bottom: 25px;
            color: #000000;
            text-indent: 2em;
            line-height: 2;
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
  .banner {
    width: 100%;
    height: 300px;
    display: flex;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    &-title {
      position: absolute;
      color: #ffffff;
      font-size: 45px;
      font-weight: 400;
      line-height: 300px;
      text-align: center;
      width: 100%;
    }
  }
}
.el-divider-active {
  background-color: #3c6088;
  height: 3px;
}
</style>